/**
 * @generated SignedSource<<dc759111d89789d43f69aa1fdb7a1955>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignedActor_actor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor" | "SignedActorBadge_actor" | "SignedActorText_actor">;
  readonly " $fragmentType": "SignedActor_actor";
};
export type SignedActor_actor$key = {
  readonly " $data"?: SignedActor_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignedActor_actor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignedActor_actor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_actor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignedActorText_actor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignedActorBadge_actor"
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "0f93824c7c78eec9bd822c7a1f1bc89b";

export default node;
